import {IRoute} from '@/utils/types';
//enums
import {ROUTER_URL} from '@/utils/enums';

export const profileTabsOrganization: IRoute[] = [
	{title: 'Settings', route: ROUTER_URL.ORGANIZATION_PROFILE_GENERAL},
	{title: 'Notifications', route: ROUTER_URL.ORGANIZATION_PROFILE_NOTIFICATION},
	{title: 'Billing', route: ROUTER_URL.ORGANIZATION_PROFILE_BILLING},
	{title: 'Team', route: ROUTER_URL.ORGANIZATION_PROFILE_TEAM},
	{title: 'Contacts', route: ROUTER_URL.ORGANIZATION_PROFILE_CONTACT_LIST},
	// {title: 'Integrations', route: ROUTER_URL.ORGANIZATION_PROFILE_INTEGRATION},
];

export const profileTabsMobOrganization: IRoute[] = [
	{title: 'Settings', route: ROUTER_URL.ORGANIZATION_PROFILE_GENERAL},
	{title: 'Notifications', route: ROUTER_URL.ORGANIZATION_PROFILE_NOTIFICATION},
	{title: 'Billing', route: ROUTER_URL.ORGANIZATION_PROFILE_BILLING},
];

export const profileTabsUser: IRoute[] = [
	{title: 'Settings', route: ROUTER_URL.PROFILE_GENERAL},
	{title: 'Notifications', route: ROUTER_URL.PROFILE_NOTIFICATION},
	{title: 'Contributions', route: ROUTER_URL.PROFILE_CONTRIBUTIONS},
];

export const profileTabsAdmin: IRoute[] = [
	{title: 'Settings', route: ROUTER_URL.PROFILE_GENERAL},
	{title: 'Notifications', route: ROUTER_URL.PROFILE_NOTIFICATION},
	{title: 'Billing', route: ROUTER_URL.ADMIN_PROFILE_BILLING},
];

export const profileUserMembers: IRoute[] = [
	{title: 'Settings', route: ROUTER_URL.ORGANIZATION_PROFILE_GENERAL},
	{title: 'Notifications', route: ROUTER_URL.ORGANIZATION_PROFILE_NOTIFICATION},
	{title: 'Contacts', route: ROUTER_URL.ORGANIZATION_PROFILE_CONTACT_LIST},
];
